/**
 * @generated SignedSource<<4874fc314ead8d841548fe9a4ad3ffbc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AddAnswerInput = {
  content?: string | null | undefined;
  questionId?: string | null | undefined;
};
export type AddAnswerMutation$variables = {
  input: AddAnswerInput;
};
export type AddAnswerMutation$data = {
  readonly addAnswer: {
    readonly answerEdge: {
      readonly __typename: "AnswerEdge";
      readonly node: {
        readonly content: string | null | undefined;
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type AddAnswerMutation = {
  response: AddAnswerMutation$data;
  variables: AddAnswerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddAnswerPayload",
    "kind": "LinkedField",
    "name": "addAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AnswerEdge",
        "kind": "LinkedField",
        "name": "answerEdge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Answer",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "content",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddAnswerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddAnswerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3ac70039610ceff584024c8c4b6dd335",
    "id": null,
    "metadata": {},
    "name": "AddAnswerMutation",
    "operationKind": "mutation",
    "text": "mutation AddAnswerMutation(\n  $input: AddAnswerInput!\n) {\n  addAnswer(input: $input) {\n    answerEdge {\n      __typename\n      node {\n        id\n        content\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6500f233f9a8589a6fe130d40d02bc35";

export default node;
